import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// TODO: Add your firebase configuration object
const firebaseConfig = {
  apiKey: "AIzaSyA8ml_r55URTnsziQ4lGVZX3W_pn0pNBN4",
  authDomain: "cems-468007.firebaseapp.com",
  projectId: "cems-468007",
  storageBucket: "cems-468007.firebasestorage.app",
  messagingSenderId: "696807560525",
  appId: "1:696807560525:web:346c637e36abd710515304",
  measurementId: "G-HJ459901QN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, { vapidKey: 'BIoe0kvHSsJnwlHb5ydSSQsu9gB4A-V7EgmJ4JmM6Y8dRPMt1m0dsOOPbZ9nA7Mm7c6FKOiBrXnnwhTylKpij8M' }); // TODO: Add your VAPID key
    if (currentToken) {
      console.log('current token for client: ', currentToken);
      // Send the token to your server and update the UI if necessary
      // ...
    } else {
      // Show permission request UI
      console.log('No registration token available. Request permission to generate one.');
    }
    return currentToken;
  } catch (err) {
    console.log('An error occurred while retrieving token. ', err);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      resolve(payload);
    });
  });
